import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { ChevronDown, Store } from "lucide-react";

export default function BranchMultiSelect({ branches, value, onChange, testid = "branch-multiselect" }) {
    const selected = value || [];
    const allSelected = selected.length === 0; // empty = all

    const toggle = (id) => {
        if (selected.includes(id)) onChange(selected.filter((x) => x !== id));
        else onChange([...selected, id]);
    };

    const selectAll = () => onChange([]);

    const summary =
        allSelected
            ? "All branches"
            : selected.length === 1
                ? branches.find((b) => b.id === selected[0])?.name || "1 branch"
                : `${selected.length} branches`;

    return (
        <Popover>
            <PopoverTrigger asChild>
                <button
                    type="button"
                    data-testid={testid}
                    className="flex items-center justify-between w-full px-3 py-2 mt-1 text-sm border border-[#E5E0D8] rounded-sm bg-white hover:bg-[#F9F8F6]"
                >
                    <span className="flex items-center gap-2 text-espresso">
                        <Store className="w-4 h-4 text-[#7A726D]" strokeWidth={1.5} />
                        {summary}
                    </span>
                    <ChevronDown className="w-4 h-4 text-[#7A726D]" />
                </button>
            </PopoverTrigger>
            <PopoverContent className="w-72 p-0 rounded-sm" align="start">
                <div className="p-2 border-b border-[#E5E0D8]">
                    <label className="flex items-center gap-2 p-2 rounded-sm hover:bg-[#F9F8F6] cursor-pointer">
                        <Checkbox
                            checked={allSelected}
                            onCheckedChange={selectAll}
                            data-testid={`${testid}-all`}
                        />
                        <span className="text-sm font-medium text-espresso">All branches</span>
                    </label>
                </div>
                <div className="max-h-64 overflow-auto p-2 space-y-0.5">
                    {branches.length === 0 && (
                        <div className="text-xs text-[#7A726D] p-2">No branches yet — add one first.</div>
                    )}
                    {branches.map((b) => (
                        <label
                            key={b.id}
                            className="flex items-center gap-2 p-2 rounded-sm hover:bg-[#F9F8F6] cursor-pointer"
                        >
                            <Checkbox
                                checked={selected.includes(b.id)}
                                onCheckedChange={() => toggle(b.id)}
                                data-testid={`${testid}-option-${b.id}`}
                            />
                            <span className="text-sm text-espresso">{b.name}</span>
                            {b.location && <span className="text-xs text-[#7A726D]">· {b.location}</span>}
                        </label>
                    ))}
                </div>
            </PopoverContent>
        </Popover>
    );
}
